import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import _ from 'lodash';

import { ApiService } from 'src/services/api.service';

@Component({
  selector: 'app-display-microsoft-teams-message',
  templateUrl: './display-microsoft-teams-message.component.html',
  styleUrls: ['./display-microsoft-teams-message.component.scss'],
})
export class DisplayMicrosoftTeamsMessageComponent implements OnInit {
  isLoading = false;

  microsoftTeamsMessageId: string;
  microsoftTeamsMessage: any;
  conversation: any;
  downloadFileId?: string;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private navController: NavController,
  ) {}

  async ngOnInit() {
    this.microsoftTeamsMessageId = this.route.snapshot.paramMap.get('microsoftTeamsMessageId');
    this.downloadFileId = this.route.snapshot.queryParamMap.get('downloadFileId');

    if (this.downloadFileId) {
      await this.downloadAttachment(this.downloadFileId);
    }

    await this.fetchMicrosoftTeamsMessage();
  }

  async fetchMicrosoftTeamsMessage() {
    const microsoftTeamsMessage: any = await this.apiService.getPromise(
      `/inbound-microsoft-teams-messages/${this.microsoftTeamsMessageId}`,
    );

    this.microsoftTeamsMessage = microsoftTeamsMessage;
    this.conversation = microsoftTeamsMessage.inbound?.slackMessage?.ticket;
  }

  dismiss() {
    if (this.conversation) {
      this.navController.navigateForward(`dashboard/inbox/${this.conversation.id}`);
    } else {
      this.navController.pop();
    }
  }

  async downloadAttachment(attachmentId: string) {
    const response: any = await this.apiService.download(`/slack/files/${attachmentId}/download`, 'GET');

    const contentDisposition: string = response.headers.get('content-disposition');
    const filename =
      contentDisposition
        .split(';')
        .find((p) => p.startsWith('filename'))
        ?.split('=')[1] ?? 'file.txt';

    const binaryData = [];

    binaryData.push(response.body);

    const downloadLink = document.createElement('a');

    downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
    downloadLink.setAttribute('download', filename);

    document.body.appendChild(downloadLink);

    downloadLink.click();
    downloadLink.remove();
  }
}
